import slide1 from './assets/slide1.webp';
import slide2 from './assets/slide2.webp';
import slide3 from './assets/slide3.webp';
import slide4 from './assets/slide4.webp';
import slide5 from './assets/slide5.webp';


export const projects = [
  {
    name: `Project One`,
    desc: `Maxime Van Roy exhibition`,
    moreInfo: `Event design - Print - Digital - Animation - Culture`,
    date: `2022`,
    slides: [slide1, slide2, slide3, slide4, slide5],
  }
  ,
  {
    name: `Project two`,
    desc: `Lorem stuff here`,
    moreInfo: `Event design - Print - Digital - Animation - Culture`,
    date: `2022`,
    slides: [slide5, slide2, slide4],
  },
  ,
  {
    name: `Project two`,
    desc: `Lorem stuff here`,
    moreInfo: `Event design - Print - Digital - Animation - Culture`,
    date: `2022`,
    slides: [slide5, slide2, slide4],
  },
  ,
  {
    name: `Project two`,
    desc: `Lorem stuff here`,
    moreInfo: `Event design - Print - Digital - Animation - Culture`,
    date: `2022`,
    slides: [slide5, slide2, slide4],
  },
  ,
  {
    name: `Project two`,
    desc: `Lorem stuff here`,
    moreInfo: `Event design - Print - Digital - Animation - Culture`,
    date: `2022`,
    slides: [slide5, slide2, slide4],
  },
];


export const navLinks={
  linkedIn:'https://www.linkedin.com/in/odunayo-alo-b48586255/',
  blog:'https://odunayo.duckdns.org/',
  github:'https://github.com/deelaurence',
  mail:'deverenceconnect@gmail.com',
  resume:'https://docs.google.com/document/d/1ycocun6oQlXJpqEl68Vz5pT_mULNujUxw3TtwhuC8hM/edit?usp=sharing'
}